export const topicsData = {
  'ai-cases': {
    title: 'Тема',
    subtitle: 'Кейсы внедрения ИИ (отраслевые практики)',
    iconSrc: '/icons/topic-icon-world-trends.svg',
    description: 'Отраслевые практики внедрения ИИ — реальные кейсы из разных сфер:',
    bullets: [
      'Поиск новых тендеров с помощью ИИ: кейс автоматизации сбора и приоритизации тендеров — как повысить релевантность и снизить ручной мониторинг.',
      'ИИ в ЖКХ.',
      'Умное зрение на производстве: автоматическое обнаружение брака и снижение потерь.',
      'ИИ для охранной деятельности: распознавание инцидентов и приоритетная аналитика.',
      'Комплексный кейс: как мы внедряем ИИ в регионах через региональные центры компетенций.',
      'Малые бюджеты — большие результаты: как региональные предприятия внедряют простые ИИ-решения.'
    ],
    speaker: {
      name: 'Светлана Федорова',
      role: 'Спикер',
      company: [
        'Создатель и руководитель Академии РИМ',
        'Председатель комитета по IT и ИИ в Деловой России г. Новосибирска',
        'Руководитель департамента по работе с субъектами РФ Ассоциации инновационных решений и искусственного интеллекта «Регионы XXI век»'
      ],
      imageSrc: '/images/topic-photo-svetlana-fedorova.png',
      imageWidth: '102.5%',
      imageHeight: '128.2%',
      imageTop: '-3.51%',
      imageLeft: '0'
    }
  },
  'sales-conversion': {
    title: 'Тема',
    subtitle: 'Как ИИ увеличивает средний чек и снижает возвраты',
    description:
      'Разбираем архитектуру RAG-систем и превращаем разрозненные данные в инструмент для стратегических решений. Рассматриваем технологии умного ритейла и e-commerce: персонализированные рекомендации, динамическое ценообразование и предиктивная аналитика, которые стабильно поднимают средний чек и сокращают возвраты.'
  },
  'ai-assistants': {
    title: 'Тема',
    subtitle: 'От промптов к командам ИИ-агентов: как построить бизнес, который работает, пока вы спите',
    description:
      'Изучаем возможности ИИ-агентов для создания круглосуточного клиентского сервиса и автоматической обработки обращений. Показываем, как выстраивать сквозную автоматизацию продаж без дорогих разработчиков. Даём инструкции по бесшовному внедрению ассистентов в CRM и мессенджеры, сокращая расходы на лиды.',
    speaker: {
      name: 'Александр Ковригин',
      role: 'Спикер',
      company: 'Основатель бизнес-клуба DAO',
      imageSrc: '/images/expert-photo-alexander-kovrigin.png'
    }
  },
  'ai-labor-market': {
    title: 'Тема',
    subtitle: 'ИИ и рынок труда',
    description:
      'Главная тема 2026 года: уравнение «человек + машина ИИ». Компаниям нужно научиться масштабировать связку человек + ИИ:',
    bullets: [
      'ИИ сам по себе недостаточен. Как эффективно сочетать человека и машину?',
      'Отношения «работодатель-сотрудник» рушатся. Нарастающая тревога сотрудников, в том числе из-за ИИ, требует пересмотра ценностного обмена.',
      'Стирание границы между HR и ИТ. Примеры интеграции ИИ в процессы управления персоналом.'
    ],
    speaker: {
      name: 'Татьяна Заворина',
      role: 'Спикер',
      company: 'Действующий HRD в fintech',
      imageSrc: '/images/topic-photo-tatyana-zavorina.png',
      imageWidth: '100%',
      imageHeight: '150%',
      imageTop: '0',
      imageLeft: '0'
    }
  },
  'ml-video-analytics': {
    title: 'Тема',
    subtitle: 'Улучшаем качество обслуживания в ритейле с помощью ML видеоаналитики',
    description:
      'Раскрываем суть компьютерного зрения и CVC-аналитики для магазинов, производства и сферы культуры. От кофеен до федеральных сетей показываем, как камеры становятся объективными контролёрами процессов. Разбираем метрики оценки обслуживания, тепловые карты и контроль выкладки, помогая стандартизировать клиентский опыт и увеличивать повторные продажи.',
    speaker: {
      name: 'Дмитрий Бызин',
      role: 'Спикер',
      company: 'CEO, Avacada',
      imageSrc: '/images/expert-photo-byzin.png'
    }
  },
  'ai-transformation': {
    title: 'Тема',
    subtitle: 'ИИ-трансформация. Почему это не про технологии, а про людей',
    description:
      'ИИ на каждый день: как мы внедрили искусственный интеллект в ДНК нашей компании. Кейс из реальной практики по внедрению ИИ в работу сотрудников.',
    speaker: {
      name: 'Татьяна Заворина',
      role: 'Спикер',
      company: 'Действующий HRD в fintech',
      imageSrc: '/images/topic-photo-tatyana-zavorina.png',
      imageWidth: '100%',
      imageHeight: '150%',
      imageTop: '0',
      imageLeft: '0'
    }
  },
  'ai-investments': {
    title: 'Тема',
    subtitle: 'Искусственный интеллект на службе инвестиционных фондов',
    description:
      'Разбираем, где ИИ реально работает в инвестициях и финансах: гибкое финансовое моделирование, скоринг и андеррайтинг, исследования рынков и инвестиционная упаковка. Показываем, как алгоритмы помогают в юридических вопросах, инвестиционной оценке и подготовке инвестиционных заключений. Говорим о прогнозировании, моделировании и управлении рисками — и о том, как измерить отдачу от внедрения и какие участки процесса автоматизировать в первую очередь.',
    speaker: {
      name: 'Андрей Заворин',
      role: 'Спикер',
      company: [
        'Профессор Банковской Финансовой Академии Республики Узбекистан',
        'Председатель правления Ассоциации профессиональных участников венчурного и инвестиционного рынка «БОЛЬШАЯ МЕДВЕДИЦА»',
        'Президент Клуба инвесторов Сибири, Урала и Дальнего Востока'
      ],
      imageSrc: '/images/expert-photo-zavorin.jpg'
    }
  },
  'ai-sales-training': {
    title: 'Тема',
    subtitle: 'ИИ НЕ ЗАМЕНИТ МЕНЕДЖЕРОВ, но заменит слабое обучение: как бизнесу тренировать продажи, сервис и коммуникации на реальных сценариях',
    description:
      'Многие компании теряют деньги не из-за плохого продукта, слабой рекламы или «не тех» клиентов. Часто сделки срываются гораздо раньше — в обычных разговорах сотрудников с клиентами. Алексей Зеленин разберёт, как ИИ можно использовать не как модную технологию, а как практический инструмент для развития сотрудников: в продажах, клиентском сервисе, адаптации новичков и контроле качества. Поговорим о том, как переводить обучение из формата «провели тренинг и надеемся на результат» в регулярную систему тренировки навыков.',
    bullets: [
      'Как может выглядеть ИИ-тренировка сотрудника на практике',
      'Какие ошибки в коммуникациях чаще всего стоят бизнесу денег',
      'С каких процессов стоит начинать внедрение ИИ, чтобы оценивать не интерес к технологии, а конкретный бизнес-результат'
    ],
    speaker: {
      name: 'Алексей Зеленин',
      role: 'Спикер',
      company: [
        'Предприниматель и сооснователь Lexis Voice',
        '14 лет в продажах',
        '9 лет обучает менеджеров и руководителей прямым продажам',
        'Создал 7 успешных отделов продаж с нуля',
        'Более 1000 обученных сотрудников',
        'Сертифицированный спикер Яндекс',
        'Работал в Яндекс, Philip Morris, JUUL Labs и с Red Bull',
        'Клиенты: ТОЧКА Банк, ОТП Банк, Лучи, FUN&SUN, Синергия, РЖД и др.',
        'Не теоретик. Практик, который ежедневно работает с продажами.'
      ],
      imageSrc: '/images/expert-photo-alexey-zelenin.jpg'
    }
  },
  'ai-enterprise': {
    title: 'Тема',
    subtitle: 'От экспериментов к системе: как крупный бизнес внедряет искусственный интеллект',
    description:
      'Опыт корпоративного внедрения: как ИИ переходит от точечных пилотов к встроенной в процессы системе. Разбираем, что отличает эксперимент от промышленного внедрения, какие ошибки на стыках отделов чаще всего ломают проект, и по каким метрикам крупный бизнес меряет реальный эффект ИИ.',
    speaker: {
      name: 'Нина Мазур',
      role: 'Спикер',
      company: [
        'IT-предприниматель с 18-летним опытом',
        'Амбассадор AI от Сбер',
        'Педагог Нетология',
        'Популяризатор искусственного интеллекта более 3 лет',
        'Спикер и практик внедрения ИИ в B2B-секторе',
        '400+ мастер-классов для бизнеса, производственных предприятий и корпоративных команд',
        'Эксперт по внедрению ИИ в рабочие процессы, автоматизации задач и повышению эффективности команд через искусственный интеллект'
      ],
      imageSrc: '/images/topic-photo-nina-mazur.png',
      imageWidth: '100%',
      imageHeight: '150%',
      imageTop: '0',
      imageLeft: '0'
    }
  }
};
